import React, { useEffect, useLayoutEffect, useRef } from 'react';

const MakeStoriesLayout = ({
    options
}) => {
    const { playerId, widgetId } = options;

    const wrapperRef = useRef(null);

    const canUseDOM = typeof window !== 'undefined';
    const useEffectHook = canUseDOM ? useLayoutEffect : useEffect;

    useEffectHook(() => {
        if (!wrapperRef.current) return;

        const playerWrapper = document.createElement('div');
        playerWrapper.id = `${playerId}`;
        playerWrapper.innerHTML = '<div id="msfb"></div>';

        wrapperRef.current.appendChild(playerWrapper);

        const styleLink = document.createElement('link');
        styleLink.href = 'https://cdn.ampproject.org/amp-story-player-v0.css';
        styleLink.rel = 'stylesheet';
        styleLink.type = 'text/css';
        document.head.appendChild(styleLink);

        const scriptUrls = [
            'https://cdn.ampproject.org/amp-story-player-v0.js',
            'https://js.makestories.io/player/StoryPlayer.js',
        ];

        let scriptsToLoad = scriptUrls.length;

        const onScriptsLoaded = () => {
            if (scriptsToLoad === 0) {
                const inlineScript = document.createElement('script');
                inlineScript.innerHTML = `msPlayer({ root: "#${playerId}", widgetId: "${widgetId}" });`;
                wrapperRef.current.appendChild(inlineScript);
            }
        };

        scriptUrls.forEach((url) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            script.onload = () => {
                scriptsToLoad--;
                onScriptsLoaded();
            };

            document.body.appendChild(script);
        });

        return () => {
            document.head.removeChild(styleLink);

            scriptUrls.forEach((url) => {
                document
                    .querySelectorAll(`script[src="${url}"]`)
                    .forEach((el) => document.body.removeChild(el));
            });

            wrapperRef.current.removeChild(playerWrapper);
        };
    }, [playerId, widgetId]);

    return (
        <div ref={wrapperRef} className='make-stories__wrapper'></div>
    );
};

export default MakeStoriesLayout;
